module.exports = __webpack_public_path__ + "static/img/group-cx@3x.3d4e311.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/group-cx@3x.png
// module id = Vmpt
// module chunks = 6